module.exports = __webpack_public_path__ + "img/head-head.2881296b.png";